export enum ScavState {
    Start,
    LoadURL,
    Failed,
    Active,
    Finish,
    LoadResults,
    Results
}
